/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Api_Keys_TrackingInputs */



/**
* | output |
* | --- |
* | "Full usage tracking per key" |
*
* @param {Plan_Gate_Benefit_Api_Keys_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_api_keys_tracking = /** @type {((inputs?: Plan_Gate_Benefit_Api_Keys_TrackingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Api_Keys_TrackingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständige Nutzungsverfolgung pro Schlüssel")
	return /** @type {LocalizedString} */ ("Full usage tracking per key")
});